import { FormField, FormFieldset } from '@domgen/dgx-fe-forms/layout';

export interface CmsModelAndSerialNumberFieldset extends FormFieldset {
  modelNumberField: FormField;
  serialNumberField: FormField;
}
